import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconExclamation(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 3.5C14 2.94772 13.5 2 12.5 2C11.5 2 11 2.94772 11 3.5V15.5C11 16 11.5 17 12.5 17C13.5 17 14 16 14 15.5V3.5Z"
        fill="currentColor"
      />
      <path
        d="M14 20.5C14 21.3284 13.3284 22 12.5 22C11.6716 22 11 21.3284 11 20.5C11 19.6716 11.6716 19 12.5 19C13.3284 19 14 19.6716 14 20.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
